export default "__VITE_ASSET__41c1face__"